import { publishSlice } from 'app/stores/publish';
import { publishToPlatform } from './platform';
export const PublishActions = Object.assign(Object.assign({}, publishSlice.actions), { publishToPlatform });
